import React from 'react';

function PlatformField({ label, children, full = false }) {
  return (
    <div className={`platform-field ${full ? 'platform-field--full' : ''}`}>
      {label && <div className="platform-field-label">{label}</div>}
      {children}
    </div>
  );
}

export default PlatformField;
